import { H2 } from "@datapay-by-datacom/design-system";
import { TriggerRunForm } from "../components/TriggerRunForm/TriggerRunForm";
import styles from "./TriggerRunScreen.module.css";

export function TriggerRunScreen() {
  return (
    <div className={styles.container}>
      <H2>Trigger Shadow Run</H2>
      <p>Configure and launch a new shadow run comparison.</p>
      <TriggerRunForm />
    </div>
  );
}
